enum ErrorCodes {
    // Fetch Errors
    FetchModelOverviewError = 'FMOV-ERR'
}

export default ErrorCodes;